import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { availableRoles } from '@/features/Sparten/unf/utils';
import { computed } from 'vue';
import { useUnfContractStore } from '@/features/Sparten/unf/useContractStore';
import { getEntries } from '@/utils/objects/objects';
import { hasMemofeld } from '@/features/Sparten/shared/sharedRenderConditions';

export const getUNFContractDehydrationDefinitions: () => ConditionalRequestDefinition[] =
  () => {
    const vpRelatedDehydrations: ConditionalRequestDefinition[] = [];

    getEntries(availableRoles.value).forEach(([role, isInUse]) => {
      if (isInUse === true) {
        vpRelatedDehydrations.push({
          if: computed(
            () => useUnfContractStore()[role].wagnisSportarten !== true,
          ),
          drop: [`${role}.wagnisSportartenMemo`],
        });
      } else {
        vpRelatedDehydrations.push({
          if: computed(() => true),
          drop: [role],
        });
      }
    });

    const temporaryFields: ConditionalRequestDefinition = {
      if: computed(() => true),
      drop: ['preliminaryContractLink'],
    };

    const hasNoWeitereVersicherung: ConditionalRequestDefinition = {
      if: computed(
        () =>
          !useUnfContractStore().weitereVersicherung
            .bestehenWeitereVersicherungen,
      ),
      drop: [
        'weitereVersicherung.gesellschaft',
        'weitereVersicherung.versicherungsnummer',
      ],
    };

    const hasMemofeldConditional: ConditionalRequestDefinition = {
      if: computed(() => !hasMemofeld.value),
      drop: ['memofeld'],
    };

    return [
      ...vpRelatedDehydrations,
      temporaryFields,
      hasNoWeitereVersicherung,
      hasMemofeldConditional,
    ];
  };
